var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { get, post } from './api';
export const pairScreen = (data) => __awaiter(void 0, void 0, void 0, function* () {
    return post({ path: '/v1/screen-pairing/pair', data });
});
export const loadPairedScreens = () => __awaiter(void 0, void 0, void 0, function* () {
    return get({ path: '/v1/screen-pairing/index' });
});
export const setScreenTheme = (id, theme) => __awaiter(void 0, void 0, void 0, function* () {
    return post({ path: '/v1/screen-pairing/set-theme', data: { id, theme } });
});
export const revokeScreen = (id) => __awaiter(void 0, void 0, void 0, function* () {
    return post({ path: '/v1/screen-pairing/revoke', data: { id } });
});
